module.exports = __webpack_public_path__ + "static/media/ic-mitrais-culture.13800b0e.svg";